/* drl-bundle-widget.js — ask Shopify's CDN for the size the bundle widget
 * actually displays.
 *
 * The app renders its item thumbnails from a bare CDN URL with no `width`
 * parameter and no srcset, so the browser downloads the full-resolution
 * product image and paints it at 80px. Measured on the live PDP: two images,
 * 1254px and 2048px natural, 80px displayed, 195KB between them.
 *
 * Shopify's CDN resizes on request, and that is the whole fix — the format is
 * already handled for us. Same file, measured:
 *
 *     no parameter   96.9 KB  webp
 *     &width=160      3.5 KB  webp
 *
 * So this is not a compression problem and pre-compressing the source would
 * not have helped: the stored original is a 1.95MB PNG and Shopify already
 * serves it as a 96.9KB WebP without being asked. Only the dimension was wrong.
 *
 * Runs against the app's markup, which we do not control, so it is written to
 * be inert when anything is unfamiliar: only Shopify CDN URLs, only when no
 * width is already set, and it never throws into the app's own code path.
 */
(function () {
  var SEL = [
    'img.bogos-bundle-item-img',
    'img.bogos-mix-item-img',
    'img.bogos-step-item-img',
    'img.bogos-bp-product-img',
  ].join(',');

  // Round up to a sane step so we reuse cache entries across slightly
  // different rendered widths rather than minting a URL per pixel.
  function step(px) {
    var sizes = [80, 120, 160, 240, 320, 480, 640];
    for (var i = 0; i < sizes.length; i++) if (px <= sizes[i]) return sizes[i];
    return 720;
  }

  function resize(img) {
    if (!img || img.dataset.drlSized) return;
    var src = img.currentSrc || img.src;
    if (!src || src.indexOf('/cdn/shop/') === -1) return;
    if (src.indexOf('width=') !== -1) { img.dataset.drlSized = '1'; return; }

    var box = img.getBoundingClientRect().width;
    // The widget often measures 0 on the tick it is inserted; wait for layout
    // rather than guessing a width, or we cache a wrong size permanently.
    if (!box) return;

    var want = step(Math.ceil(box * (window.devicePixelRatio || 1)));
    img.dataset.drlSized = '1';
    img.src = src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + want;
  }

  function sweep(root) {
    try {
      (root || document).querySelectorAll(SEL).forEach(resize);
    } catch (e) { /* the app's markup changed; leave its images alone */ }
  }

  function start() {
    sweep();
    var host = document.querySelector('.drl-bundle-scope') || document.body;
    if (!window.MutationObserver) return;
    // The widget is injected after load and re-renders on variant change.
    var mo = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) sweep(added[j]);
        }
      }
      sweep(host);
    });
    mo.observe(host, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
